import React, { memo, useCallback } from 'react';

import { StyledAutoComplete, StyledTextField } from './styles';
import {isGloboCurrentApp} from '../../utils/get-app-env'

type FieldProps = {
  options: Array<any>;
  userValue?: any;
  setUserValue: React.Dispatch<React.SetStateAction<any>>;
  textValue: string;
  setTextValue: React.Dispatch<React.SetStateAction<string>>;
  inputLabel: string;
  noOptionsText?: string;
  customRef?: any;
  userRole?: string;
  onSelect?: any;
};

const CustomField = memo(
  ({
    options,
    userValue,
    setUserValue,
    textValue,
    setTextValue,
    inputLabel,
    noOptionsText,
    customRef,
    userRole,
    onSelect
  }: FieldProps) => {
    return (
      <StyledAutoComplete
        ref={customRef}
        debug
        closeIcon={<></>}
        value={userValue}
        noOptionsText={noOptionsText}
        autoHighlight={true}
        onChange={(
          event: React.ChangeEvent<{}>,
          newValue: any,
          reason: any
        ) => {
          if(onSelect) {
            onSelect(newValue);
          }
          setUserValue(newValue);
        }}
        inputValue={textValue}
        getOptionSelected={useCallback(
          (option: any, value: any) => {
            return (
              option?.label === value?.label || option?.name === value?.name
            );
          },
          []
        )}
        getOptionLabel={(option: any) => {
          if (userRole === 'ROLE_ADMIN') {
            return option.nameLabel;
          }

          return option?.label;
        }}
        onInputChange={(event, newInputValue: string) => {
          setTextValue(newInputValue);
        }}
        id={`${Math.random()}`}
        options={options}
        renderOption={(option: any) => (
          <React.Fragment>
            {isGloboCurrentApp() ?
            <span>{option?.label}</span> :
            <span className='mp-autocomplete-fragment'>{option?.label}</span>
            }
          </React.Fragment>
        )}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            label={inputLabel}
            variant="outlined"
            inputProps={{ ...params.inputProps, autoComplete: 'Escolher a praça' }}
          />
        )}
      />
    );
  }
);

export default memo(CustomField);
